<template>

	<div
		class="backlinks"
	>

		<div class="search-box">

			<p v-html="openingText" v-if="openingText" />

			<span @click="searchDefault" class="large-button default">Search</span>

			<span @click="tableTriggerSomething='multipleSearchModal'" class="large-button custom">Custom</span>

		</div>

		<Table
			v-if="loaded"
			:key="tableKey"
			:headings="tableHeadings"
			:items="tableItems" 
			:pages="resultsTable.pages"
			:pageClassRules="pageClassRules"
			:page="resultsTable.page"
			:count="resultsTable.count"
			:loading="tableLoading"
			:sorted="resultsTable.sorted"
			:searchMultiple="true"
			:searchMultipleValues="tabSearchFilters"
			:searchMultipleGroups="tableSearchGroupSetup"
			:searchMultipleDescription="searchDescription"
			:searchTitle="searchTitle"
			:searchMultipleTitle="searchMultipleTitle"
			:searchMultipleButtonLabel="searchFilterLabel"
			:searchMultipleComparisons="comparisons"
			:searchMultipleSelects="selects"
			:searchMultipleMaxLines="8"
			:searchMultipleAddAnotherLabel="'Add another filter set'"
			:meta="tableMeta"
			:showTable="showTable"
			:name="tableName"
			:triggerSomething="tableTriggerSomething"
			:searchMultipleOrderByList="searchMultipleOrderBy.list"
			:searchMultipleOrderByDefault="searchMultipleOrderBy.default"
			:searchMultipleOrderByDefaultDirection="searchMultipleOrderBy.direction"
			:searchMultipleOrderByMax="searchMultipleOrderBy.max"
			@trigger-complete="triggerComplete"
			:hideSearch="hideSearch"
			@closeSearchMultiple="closeSearchMultiple"
			@pagination="pagination"
			@sort="sort"
			@selected="keywordActions"
			@search="search"
			@viewBacklinks="viewBacklinks"
			:searchSetup="searchSetup"
			loadingText="Loading keywords..."
			:emptyLabel="emptyTableLabel"
			emptySearch="There were no keywords matching your search"
			class="results no-corners no-bg-search"
		/>

		<div class="why" v-if="showWhyPageNumbers">Why are some of the page numbers red?</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import general from '../../utils/general'
import ApiService from './../../services/api.service'
import Table from './../Table.vue'
import LinkWithIcon from './../Display/LinkWithIcon.vue'
export default {
	name: 'Backlinks',
	components: { Table },
	props: {
		type: {
			type: String
		},
		tabId: {
			type: String
		},
		md5Key: {
			type: String
		}
	},
	data() {

		return {
			tableKey: 0,
			tableLoading: false,
			tableItemSelected: [],
			searchFilters: {},
			orderBy: {},
			tableTriggerSomething: '',
			tabSearchFilters: [],
			table: {
				page: 1,
				sorted: { avgMonthlySearches: -1 },
				search: {},
				items: [],
				count: 0
			},
			fields: {},
			selects: {},
			groups: {},
			comparisons: {},
			loaded: false
		}

	},
	watch: {
		searchId () {
			this.loadList();
		}
	},
	computed: {

		...mapState('general',['dateTimeFormat']),

		showWhyPageNumbers () {

			return this.table.totalPages && this.table.allowedPages && this.table.totalPages > this.table.allowedPages;

		},

		pageClassRules () {

			let rules = [];

			if ( this.showWhyPageNumbers ) {

				rules.push({
					'from': this.table.allowedPages + 1,
					'to': this.table.totalPages,
					'class': 'red'
				});

			}

			return rules;

		},

		queryVars () {

			let queryVars = {};

			if ( this.table.page && parseInt( this.table.page ) > 1 ) {
				queryVars.page = this.table.page;
			}

			return Object.keys( queryVars ).length > 0 ? ( '?' + new URLSearchParams(queryVars).toString() ) : '';

		},

		tableName () {

			let r = "backlinks-table";

			if ( this.searchId ) {
				r += "-searched"
			}

			return r;

		},

		searchId () {

			return this.$route.params._id || null;

		},

		openingText () {

			switch ( this.type ) {

				case 'backlinks':

					return "By default we will return all backlinks for your domain that do not have a nofollow tag, they will be ordered by Page Score highest to lowest.";

				case 'referring-domains':
				case 'referring_domains':

					return "By default we will return all referring domains ordered by their Score highest to lowest.";

			}

		},

		showTable () {
			return true;
			return this.hasSearched;

		},
		searchTitle () {

			return this.hasSearched ? "Filter" : "Click the search button below to add filters";

		},
		searchFilterLabel () {

			return this.hasSearched ? "Search" : "Search";

		},
		searchDescription () {

			return "You can only add a maximum of 8 filters!";

		},
		hideSearch () {

			return !this.hasSearched;

		},
		emptyTableLabel () {

			return 'You haven\'t searched for any backlinks yet.';

		},
		searchMultipleTitle () {

			switch ( this.type ) {

				case 'backlinks' :

					return "Backlink Filters";

				break;

				case 'referring-domains' :

					return "Referring Domains Filters";

				break;

			}

			return this.hasSearched ? "Filter" : "Filter";

		},
		searchMultipleOrderBy () {

			let o = { list: [], default: null, direction: null, max: 3 };

			Object.keys( this.fields ).forEach ( function ( f ) {

				if ( this.fields[f].searchVars && this.fields[f].searchVars.orderBy ) {

					let index = this.fields[f].searchVars.orderBy.indexOf(this.type);

					if ( index >= 0 ) {

						o.list.push({ _id: f, label: this.fields[f].searchVars.showLabel });

						if ( this.fields[f].searchVars.orderByDefault && this.fields[f].searchVars.orderByDefault[index] ) {

							o.default = f;
							o.direction = this.fields[f].searchVars.orderByDefault[index];

						}

					}

				}

			}.bind(this));

			o.list = o.list.sort((a, b) => {
				return b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 1;;
			})

			return o;

		},
		hasSearched () {

			return false;

		},
		tableSearchGroupSetup () {

			return this.groups;

		},

		resultsTable () {

			return this.table;

		},
		tableMeta() {

			return {};

		},
		tableHeadings() {

			let headings = {
				domain: { value: 'Domain', component: LinkWithIcon, event: 'viewBacklinks', 'clickVars': ['_id'], sort: -1 },
				total_count: { value: 'Total Backlinks Available' },
				filterDescription: { value: 'Filters' },
				orderByDescription: { value: 'Ordered By' }
			};

			if ( this.$route.params._id ) {

				headings = {};

				Object.keys( this.fields ).forEach ( function ( f ) {

					if ( this.fields[f].types.indexOf(this.type) >= 0 && this.fields[f].placements.indexOf('table') >= 0 ) {

						headings[f] = this.fields[f];

						if ( this.fields[f].searchVars ) {

							if ( this.fields[f].searchVars.type === 'date-range' ) {

								headings[f].dateFormat = this.dateTimeFormat;

							}

							if ( this.fields[f].searchVars.url ) {

								headings[f].component = LinkWithIcon;

							}

						}

					}

				}.bind(this));

			}

			return headings;

		},

		tableItems () {

			if ( this.$route.params._id || this.searchId ) {

				return this.resultsTable.items;

			}

			let items = [];

			let f = {
				"order_by": [
					"page_from_rank,desc"
				],
				"filters": [
					[
					"dofollow",
					"=",
					true
					]
				]
			};

			this.resultsTable.items.forEach ( function (item) {

				item.filterDescription = [];

				item.filters.filters.forEach ( function (filter) {

					if ( !Array.isArray( filter ) ) return;

					let label = this.fields[filter[0]].searchVars.showLabel || this.fields[filter[0]].value, 
						comparison = '<em>' + this.comparisons[filter[1]] + '</em>',
						value = filter[2];

					if ( this.fields[filter[0]].searchVars.boolean ) {

						value = !!filter[2] ? 'Yes' : 'No';

					}

					item.filterDescription.push( label + ' ' + comparison + ' ' + value );

				}.bind(this));

				item.filterDescription = item.filterDescription.join(' AND ');

				item.orderByDescription = 'Not set';

				if ( item.filters.order_by && item.filters.order_by.length > 0 ) {

					let orderBy = [];

					item.filters.order_by.forEach ( function (order_by) {

						order_by = order_by.split(',');

						orderBy.push( this.fields[order_by[0]].value + ' ' + ( order_by[1] === 'desc' ? '<em>Descending</em>' : '<em>Ascending</em>' ) );

 					}.bind(this));

					item.orderByDescription = orderBy.join(', ');

				}
				
				items.push(item);

			}.bind(this));

			return items;

		},

		searchSetup() {

			let filters = {};

			Object.keys( this.fields ).forEach ( function ( f ) {

				if ( this.fields[f].types.indexOf(this.type) >= 0 && this.fields[f].placements.indexOf('filters') >= 0 ) {

					filters[f] = general.stripObject ( this.fields[f].searchVars );

					let group = null;

					if ( filters[f].group ) {

						if ( typeof filters[f].group === 'object' ) {

							if ( filters[f].group[this.type] ) group = filters[f].group[this.type];

						}
						else {

							group = filters[f].group;

						}

						if ( group ) 
							filters[f].group = group;
						else 
							delete filters[f].group;

					}

				}

			}.bind(this));

			return filters;

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		closeSearchMultiple (info) {

			Vue.set( this.searchFilters, this.tabId, info.query );
			Vue.set( this.orderBy, this.tabId, info.orderBy );
			this.tableTriggerSomething = 'closeSearchModal';
			this.loadResults ();

		},

		searchDefault () {

			this.loadResults (true);

		},

		triggerComplete (type) {

			this.tableTriggerSomething = '';

		},

		viewBacklinks ( info ) {

			this.$router.push('/website-analysis/'+`${this.$route.params.type}/${this.$route.params.key}/${this.$route.params.tabId}/${info._id}`)

		},

		keywordActions(ids) {

			Vue.set(this,'tableItemSelected',ids);

		},

		search(info) {

			Vue.set( this.table, 'search', info );
			Vue.set( this.table, 'page', 1 );

			this.loadResults ();

		},

		sort(info) {
			
			Vue.set( this.table, 'sorted', info );
			Vue.set( this.table, 'page', 1 );
			if ( info.init ) { delete this.table.sorted.init; return; }
			this.loadResults ();

		},

		pagination(info) {

			if ( this.searchId ) {

				if ( this.table.allowedPages && info.page > this.table.allowedPages ) {

					alert('You have reached the maximum number of pages allowed for this search. Please refine your search to see more results.');

				}

			}

			Vue.set( this.table, 'page', info.page );
			this.loadList ();

		},

		loadResults ( clear ) {

			let postVars = [],
				count = 0, 
				bodyVars = { default: true };

			if ( !clear ) {

				this.searchFilters[this.tabId].forEach ( function (f) {

					let vars = [];

					Object.keys( f ).forEach ( function (fieldNameFull) {

						let fieldVars = {}, 
							fieldName = fieldNameFull.split('___')[0];

						if ( this.fields[fieldName] && this.fields[fieldName].searchVars ) {

							let type = this.fields[fieldName].searchVars.type;

							switch ( type ) {

								case 'number-from-to' :
								case 'date-range' :

									if ( !f[fieldNameFull] ) break;

									let ops = type === 'number-from-to' ? ['from','to'] : ['start','end'];

									ops.forEach( function (v) {

										if ( f[fieldName][v] ) {

											fieldVars[fieldName] = fieldVars[fieldName] || {};
											fieldVars[fieldName][v] = f[fieldNameFull][v];
											++count;

										}

									}.bind(this));

								break;

								case 'number' :

									if ( ( f[fieldNameFull] && !isNaN( f[fieldNameFull] ) ) || f[fieldNameFull] === 0 ) {

										fieldVars[fieldName] = ( f[fieldNameFull] + '' );
										++count;

									}

								break;

								default : 

									if ( !f[fieldNameFull] ) break;

									if ( typeof f[fieldNameFull] === 'object' ) {

										if ( Array.isArray( f[fieldNameFull] ) ) {

											if ( f[fieldNameFull].length ) {

												fieldVars[fieldNameFull] = f[fieldNameFull];
												++count;

											}

										}
										else if ( f[fieldNameFull].value || typeof f[fieldNameFull].value === 'boolean' ) {
											fieldVars[fieldNameFull] = f[fieldNameFull];
											++count;
										}
									}
									else if ( typeof f[fieldNameFull] === 'boolean' || f[fieldNameFull] ) {
										fieldVars[fieldNameFull] = f[fieldNameFull];
										++count;
									}

							}

						}

						if ( fieldVars[fieldNameFull] ) vars.push( { fieldName: fieldName, info: fieldVars[fieldNameFull] } )

					}.bind(this));

					if ( Object.keys( vars ).length > 0 ) postVars.push(vars);

				}.bind(this));

				if ( postVars.length === 0 ) return;
				
				if ( count > 8 ) {

					this.$snotify.error( "Sorry you can only use upto 8 filters (you have "+count+")", "Error");
					this.tabSearchFilters = general.stripObject( this.searchFilters[this.tabId] );
					this.tableTriggerSomething = 'multipleSearchModal';
					return;

				}

				bodyVars = { query: postVars, orderBy: this.orderBy[this.tabId] };

			}
			
			this.loading(true);
			
			ApiService.post( 'domain-analysis/' + this.type + '/' + this.md5Key + '/' + this.tabId, bodyVars )
            .then( function(info) {

				this.loading(false);

				this.viewBacklinks ( { _id: info.data.searchId } );

            }.bind(this))
            .catch( function(err) {

				this.loading(false);
				this.$snotify.error(err.response.data.error, 'Search Error');

			}.bind(this));

		},

		loading ( loading ) {

			this.tableLoading = !!loading;

		},

		loadList () {

			ApiService.get( 'domain-analysis/' + this.type + '/' + this.md5Key + '/' + this.tabId + ( this.searchId ? ( '/' + this.searchId ) : '' ) + this.queryVars )
            .then( function(info) {

				this.loading(false);
				Vue.set( this, 'table', info.data );
				this.loaded = true;

            }.bind(this))
            .catch( function(err) {

				this.loading(false);
				this.$snotify.error(err.response.data.error, 'Search Backlinks');

			}.bind(this));

		}

	},
	created() {

		this.loading(true);

		ApiService.get( 'fields' )
		.then( function(info) {

			this.loading(false);

			['fields','groups','selects','comparisons'].forEach( function (ff) {

				Vue.set( this, ff, info.data[ff] );

			}.bind(this));

			this.loadList();

		}.bind(this))
		.catch( function(err) {}.bind(this));

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.backlinks {

	.why {

		text-align: center;
		text-decoration: underline;
		color: @red;
		font-size: 12px;
		font-weight: @bold;
		cursor: pointer;

		&:hover {

			text-decoration: none;

		}

	}

	.search-box {

		margin-top: 30px;
		text-align: center;

		p {

			width: 100%;
			margin: 0 0 25px;

		}

		.large-button {

			position: relative;
			margin: 0 0 0 20px;
			display: inline-block;

			&:after {

				content: "using default settings";
				display: block;
				text-align: center;
				width: 100%;
				font-size: 0.6em;

			}

			&.custom {

				&:after {

					content: "add your own filters";

				}

			}

		}

	}

}
.results {
	margin-top: 20px;
}
@media screen and (min-width: 768px) {
	.backlinks {

		.search-box {

			display: flex;
			text-align: left;

			p {

				width: 50%;
				margin: 0;

			}

		}

	}
}
</style>